import { SET_MAIN_LOADING, SET_CLIENT_DROPDONW_DATA } from "../types/index";
import * as api from "../api/index";
import { handleApiError } from "Helper";
import { getActiveFeeEarner } from "services/userService";

export const setMainLoading = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: SET_MAIN_LOADING, payLoad: payLoad });
  } catch (error) { }
};